import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step9 from './Step9-redux';

export default compose(
  withRouter,
  withNextStep
)(Step9);
